import React, {useState, useEffect} from 'react'
import {BgLogoBlue, FbLogo, TwitterLogo, GooglePlusLogo, LinkedInLogo, BgLogoWhite} from '../../images/index.js'
import { Link, useLocation, useHistory } from 'react-router-dom';
import useApp from '../../store/app/appContext.js';

export default function Footer({light}) {

  const history = useHistory();
  const location = useLocation();
  const currentLocation = location.pathname;
  const { logout, appState: { isAuthenticated, user } } = useApp();

  const [currentUser, setCurrentUser] = useState("");

  const scheduleScan = () => {
    if (isAuthenticated) {
      history.push('/scanandgo')
    } else {
      history.push('/login?scanandgo=true')
    }
  }

  useEffect(() => {
    if(window.location.pathname.includes("/professional")) {
      return setCurrentUser("Professional")
    } else if(window.location.pathname.includes("/patient")) {
      return setCurrentUser("Patient")
    }
  }, [window.location.pathname])
  
  const date = new Date();
  const currentYear = date.getFullYear();

  const BACKGROUND = {
    color: light ? "black" : "white",
    backgroundColor: light ? "#FFF" : "#1A1A1A"  
  }

  return (
    <div className="grid flex-col justify-center pt-4 m-0" style={BACKGROUND}>
      <div className="pt-6 md:pt-18">
        {light ? 
        <img className="mx-auto object-contain w-80" src={BgLogoBlue} alt="XiViX Logo"/>
        :
        <img className="mx-auto object-contain w-80" src={BgLogoWhite} alt="XiViX Logo"/>
        }
      </div>
      <div className="navbar m-6">
        <ul className="flex flex-col sm:flex-row place-items-center justify-center gap-1 sm:gap-8">
          <li className="font-light">
          {currentUser === "Patient" ? 
            <Link to="/patient/about-us">About us</Link> 
            : 
            <Link to="/professional/about-us">About us</Link>
          }
          </li>
          <li className="font-light">
          {currentUser === "Patient" ? 
          <Link to="/patient/careers">Careers at XiViX</Link> 
            : 
          <Link to="/professional/careers">Careers at XiViX</Link>
          }
          </li>
          {currentUser === "Patient" ?
          <li className="font-light cursor-pointer" onClick={()=>scheduleScan()}>Schedule a Scan & Go</li>
          :
          <li className="font-light cursor-pointer" onClick={() => history.push('/professional/become-a-partner')}>Schedule a Meeting</li>
          }
        </ul>
      </div>
      <div className="login-with">
      <ul className="flex flex-row align-items-stretch justify-center gap-5">
          <li className="w-10 h-10 rounded-full bg-black overflow-hidden flex justify-around items-center"><img src={FbLogo}/></li>
          <li className="w-10 h-10 rounded-full flex justify-around items-center"><img src={TwitterLogo}/></li>
          <li className="w-10 h-10 rounded-full flex justify-around items-center"><img src={GooglePlusLogo}/></li>
          <li className="w-10 h-10 rounded-full flex justify-around items-center"><img src={LinkedInLogo}/></li>
        </ul>
      </div>
      <div className="copyright text-center mt-10 mb-10">
        <p>Copyright {currentYear} | All rights reserved</p>
      </div>
    </div>
  )
}
